export const myLanguages = [
    {
        name : 'React',
        level : 6,
        useAreas : ['Web Uygulaması']
    },
    {
        name : 'Python',
        level : 4,
        useAreas : ['Makine Öğrenmesi', 'Web Uygulaması', 'Windows Uygulaması']
    },
    {
        name : 'Javascript',
        level : 7,
        useAreas : ['Web Uygulaması', 'Web Server']
    },
    {
        name : 'Typescript',
        level : 6,
        useAreas : ['Web Server']
    },
    {
        name : 'SQL',
        level : 4,
        useAreas : ['Veritabanı Tasarımı', 'MySQL', 'MongoDB', 'Microsoft SQL']
    },
    {
        name : 'Dart',
        level : 7,
        useAreas : ['Mobil Uygulaması', 'Web Server']
    },
    {
        name : 'Flutter',
        level : 6,
        useAreas : ['Mobil Uygulaması']
    },
]